import script from "./VInputTags.vue?vue&type=script&lang=ts&setup=true"
export * from "./VInputTags.vue?vue&type=script&lang=ts&setup=true"

import "./VInputTags.vue?vue&type=style&index=0&id=5970e37a&lang=sass"

const __exports__ = script;

export default __exports__